import { AxiosInstance } from "axios";
import { Dispatch } from "redux";
import { } from "redux-thunk";
import { IStateTree } from "../../interfaces";
import { showNotification } from "../../notification/actions";

import { GET_MODERATION_PROCESS } from "../types";

export default (planId: string) => async (dispatch: Dispatch, getState: () => IStateTree, api: AxiosInstance) => {
    dispatch({
        type: GET_MODERATION_PROCESS,
        payload: null,
    });
    try {
        const { data } = await api.get(`/test-moderation/moderation-info/${planId}`);
        dispatch({
            type: GET_MODERATION_PROCESS,
            payload: data,
        });
    } catch (error) {
        dispatch(showNotification(error.toString(), "warning"));
    }
};
